var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"jss-loading"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }